import React from "react";

const WarehouseSelector = ({
  warehouses = [],
  selectedWarehouseId,
  onChange,
  isLoading,
  error,
}) => {
  if (isLoading) {
    return <div className="text-sm text-gray-500">در حال دریافت انبارها...</div>;
  }

  if (error) {
    return (
      <div className="rounded-lg border border-red-200 bg-red-50 p-3 text-sm text-red-700">
        خطا در دریافت لیست انبارها
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-2 md:max-w-sm">
      <label className="text-sm font-medium text-gray-700">انتخاب انبار</label>
      <select
        className="rounded-lg border px-3 py-2 outline-none focus:border-blue-500"
        value={selectedWarehouseId || ""}
        onChange={(e) => onChange(e.target.value)}
      >
        <option value="">یک انبار انتخاب کنید</option>
        {warehouses.map((warehouse) => (
          <option key={warehouse.id} value={warehouse.id}>
            {warehouse.title}
          </option>
        ))}
      </select>
    </div>
  );
};

export default WarehouseSelector;
